// libs
import React from 'react';
import PropTypes from 'prop-types';
// errors
import Errors from 'dux/errors/errors';
// shared components
import { Alert, ShoppingIcon } from 'components/library';
import LoaderButton from '../../loader-button';
import { LocaleString } from '@biw/intl';
// utils
import { openCatalog } from '../shop-utils';

export default class CatalogButton extends React.Component {

    static propTypes = {
        busy: PropTypes.bool,
        dismissErrorsByType: PropTypes.func.isRequired,
        fetchCatalogUrlErrors: PropTypes.any,
        hideButton: PropTypes.bool,
        showIcon: PropTypes.bool,
        fetchCatalogUrl: PropTypes.func.isRequired,
        buttonLocaleCode: PropTypes.string,
        disabled: PropTypes.bool,
        branding: PropTypes.bool,
        brandingInverted: PropTypes.bool,
        tabIndex: PropTypes.number

    }

    static defaultProps = {
        showIcon: false,
        hideButton: false,
        disabled: false,
        branding: false,
        brandingInverted: false
    }

    openCatalog = ( event ) => {
        const { disabled, fetchCatalogUrl } = this.props;
        if ( !disabled ) {
            openCatalog( event, fetchCatalogUrl );
        }
    };

    handleAlertDismiss = ( ) => {
        this.props.dismissErrorsByType( Errors.ERROR_SHOP_FETCH_CATALOG_URL );
    };

    render() {
        const{
            fetchCatalogUrlErrors,
            hideButton,
            showIcon,
            busy,
            buttonLocaleCode,
            disabled,
            branding,
            brandingInverted,
            tabIndex
        } = this.props;

        return(
            <div className="catalog-btn-wrapper">

                { fetchCatalogUrlErrors.length !== 0 && !showIcon &&
                    <Alert type={ 'error' } onDismiss={ this.handleAlertDismiss  }>
                        <LocaleString className="shop-warning-message" code="shop.warningMessage" />
                    </Alert>
                }

                { ( !hideButton || busy ) && !showIcon &&
                    <LoaderButton
                        data-sel="open-catalog-button"
                        disabled={ disabled }
                        fetching={ busy }
                        handleClick={ this.openCatalog }
                        branding={ branding }
                        brandingInverted={ brandingInverted }
                        tabIndex={tabIndex}
                    >
                        <LocaleString code={ buttonLocaleCode } />
                    </LoaderButton>
                }

                { ( showIcon && hideButton ) &&
                    <a onClick={ this.openCatalog }>
                        <ShoppingIcon/>
                    </a>
                }
            </div>
        );
    }
}



